import React from 'react';
import logo from "../images/mobile-app.svg"

function Logo(){
    return (
      <div>
          <img src={logo} id ="logo" alt="" width="150"/>
      </div>
    );
  
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js